import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import {
	FileGroup,
	TextAreaField,
	// SelectFieldStatus
} from "../../../components/Form/FormComponents";
import ActionSideBar from "../partials/ActionSideBar";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { LeaseeInformation, LeasorInformation, RequestInformationLease } from "../partials/FormFieldsLease";
import { ApprenticeInformation, InvestorInformation, RequestInformationAF } from "../partials/FormFieldsAF";
import { useUploadFile } from "../../../utils/useUpload";

// eslint-disable-next-line no-unused-vars
const AwaitingForm = ({ requestData, setRequestData, filter }) => {
	const [formData, setFormData] = useState(requestData);
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";
	const isLeasing = filter === "lease";

	const [assetInvoice, setAssetInvoice] = useState(null);

	const [miniInfo, setMiniInfo] = useState({
		engineNum: formData?.vehicleInfo?.engineNum || "",
		chassisNum: formData?.vehicleInfo?.chassisNum || "",
		assetInvoice: formData?.assetInvoice || formData?.vehicleInfo?.assetInvoice || null,
	});

	const [paymentReceipt, setPaymentReceipt] = useState(null);

	const handleInputChange = (e) => {
		setMiniInfo({ ...miniInfo, [e.target.name]: e.target.value });
	};

	// eslint-disable-next-line no-unused-vars
	const handleCancel = () => {
		setFormData(requestData);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setRequestData(formData);
	};

	const handleFileUpload = (e) => setAssetInvoice(e.target.files[0]);
	const handleFileUploadTwo = (e) => setPaymentReceipt(e.target.files[0]);

	const { loading: invoiceLoading, fileUploadSuccess } = useUploadFile(assetInvoice || paymentReceipt);

	const updatedData = {
		lease: {
			vehicleInfo: {
				engineNum: miniInfo?.engineNum,
				chassisNum: miniInfo?.chassisNum,
				assetInvoice: fileUploadSuccess || miniInfo?.assetInvoice,
				vehicleBrand: formData?.productObj?.brand,
				vehicleName: formData?.productObj?.productName,
			},
		},
	};

	const assetInvoiceData = {
		lease: {
			assetInvoice: fileUploadSuccess || miniInfo?.assetInvoice,
		},
		AfData: {
			paymentReceipt: fileUploadSuccess || requestData?.paymentReceipt,
		},
	};

	const assetRegInfo =
		formData?.productObj?.category === "Vehicles" ? updatedData?.lease : assetInvoiceData?.lease;

	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar
					requestData={formData}
					action={action}
					setAction={setAction}
					handleCancel={handleCancel}
					canEditStatus={true}
					isEditable={isEditable}
					options={["Awaiting Procurement"]}
					updatedData={formData?.productObj?.category === "Vehicles" ? updatedData : assetInvoiceData}
					keyValue='assetRegInfo'
					assetDateToUpdate={assetRegInfo}
				/>

				<div className='RightSection'>
					<FormAccordion title='Request Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							{isLeasing ? (
								<RequestInformationLease
									formData={formData}
									miniInfo={miniInfo}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
									handleFileUpload={handleFileUpload}
									invoiceLoading={invoiceLoading}
									fileInfo={fileUploadSuccess || miniInfo?.assetInvoice}
									showDeliveryDetails
								/>
							) : (
								<RequestInformationAF
									formData={formData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
									fileInfo={fileUploadSuccess || requestData?.paymentReceipt}
									handleFileUpload={handleFileUploadTwo}
									invoiceLoading={invoiceLoading}
									fileOneEnabled={isEditable}
									// fileTwoEnabled={isEditable}
								/>
							)}
						</div>
					</FormAccordion>

					{isLeasing ? (
						<>
							<FormAccordion title='Product description'>
								<div className='form-group'>
									<TextAreaField
										name='product_desc'
										value={formData?.description || formData?.productId?.description}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Key features'>
								<div className='form-group'>
									<TextAreaField
										name='keyFeatures'
										value={formData?.keyFeatures && formData?.keyFeatures?.replace(/;/g, "<br/>")}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Product specifications'>
								<div className='form-group'>
									<TextAreaField
										name='specifications'
										value={formData?.specifications && formData?.specifications?.replace(/;/g, "<br/>")}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Leasor’s Information'>
								<LeasorInformation formData={formData} />
							</FormAccordion>

							<FormAccordion title='Leasee’s Information'>
								<LeaseeInformation formData={formData} />
							</FormAccordion>
						</>
					) : (
						<>
							<FormAccordion title='Proof of purchase'>
								<div className='form-group'>
									<FileGroup value={formData?.proofOfPurchaseFile?.url} />
								</div>
							</FormAccordion>

							<FormAccordion title='Investor’s Information'>
								<InvestorInformation formData={formData} />
							</FormAccordion>

							<FormAccordion title='Apprentice’s Information'>
								<ApprenticeInformation formData={formData} />
							</FormAccordion>
						</>
					)}
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
AwaitingForm.propTypes = {
	requestData: PropTypes.object,
	setRequestData: PropTypes.func,
	filter: PropTypes.string,
	updateCurrentObject: PropTypes.func,
};

export default AwaitingForm;
